module.exports = __webpack_public_path__ + "media/images/lb/771-e08dbfcde7a29966fac0158c40061380.svg";